import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { COMPARISON_GROUPS, COMPARISON_COLUMN, getPlanKey } from './planContent';
import styles from './PlanComparisonTable.module.css';

const Cell = ({ value }) => {
  if (value === true) {
    return <CheckIcon className={styles.check} aria-label="Incluído" />;
  }
  if (value === false) {
    return <span className={styles.dash} aria-label="Não incluso">—</span>;
  }
  return <span className={styles.value}>{value}</span>;
};

/**
 * "Compare os planos": grupos de recursos com uma coluna por plano.
 * Só entram os planos que têm coluna em planContent (os demais ficam só no card).
 *
 * @param {Array}  plans          — planos visíveis, na ordem da página
 * @param {*}      currentPlanId  — id do plano em uso (destaca a coluna)
 */
const PlanComparisonTable = ({ plans, currentPlanId }) => {
  const columns = plans
    .map((plan) => ({ plan, index: COMPARISON_COLUMN[getPlanKey(plan)] }))
    .filter((col) => col.index !== undefined);

  if (columns.length === 0) return null;

  // eslint-disable-next-line eqeqeq
  const isCurrent = (plan) => currentPlanId != null && plan.id == currentPlanId;

  return (
    <section className={styles.section} aria-labelledby="plans-compare-title">
      <h2 id="plans-compare-title" className={styles.title}>Compare os planos</h2>

      <div className={styles.wrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th scope="col" className={styles.featureHead}>Recurso</th>
              {columns.map(({ plan }) => (
                <th
                  key={plan.id}
                  scope="col"
                  className={`${styles.planHead} ${isCurrent(plan) ? styles.colCurrent : ''}`}
                >
                  <span className={plan.contact_sales ? styles.planNameContact : undefined}>{plan.name}</span>
                  {isCurrent(plan) && <span className={styles.currentTag}>Seu plano</span>}
                </th>
              ))}
            </tr>
          </thead>
          {COMPARISON_GROUPS.map((group) => (
            <tbody key={group.title}>
              <tr className={styles.groupRow}>
                <th scope="colgroup" colSpan={columns.length + 1}>{group.title}</th>
              </tr>
              {group.rows.map((row) => (
                <tr key={row.label} className={styles.row}>
                  <th scope="row" className={styles.feature}>
                    {row.label}{row.third ? '*' : ''}
                  </th>
                  {columns.map(({ plan, index }) => (
                    <td
                      key={plan.id}
                      className={`${styles.cell} ${isCurrent(plan) ? styles.colCurrent : ''}`}
                    >
                      <Cell value={row.values[index]} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </div>
    </section>
  );
};

export default PlanComparisonTable;
